import { render, staticRenderFns } from "./sectionLayout.vue?vue&type=template&id=148b44be&scoped=true&"
import script from "./sectionLayout.vue?vue&type=script&lang=ts&"
export * from "./sectionLayout.vue?vue&type=script&lang=ts&"
import style0 from "./sectionLayout.vue?vue&type=style&index=0&id=148b44be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b44be",
  null
  
)

export default component.exports